export default "/images/claritick-icon-3.svg?4a8174c0649c8ee647bc012cb75d6952";